import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, ElementRef, ViewChild, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {ConfigStateService} from "../../../../../app/config/config-state.service";
import { TaxReturnService, ProcessStateService } from "../../../../../../swaggerServices";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";


declare var $: any;

@Component({
    selector: "schedule-package-generation",
    templateUrl: "./schedule-package-generation.component.html",
    styleUrls: ["./schedule-package-generation.component.scss"],
    standalone: false
})
export class SchedulePackageGeneration implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentBatchList;
  @Input() batchId;
  @Input() clientId;
  @Input() year;
  @Output() completed = new EventEmitter();
  showModal = true;
  responseData = [];
  scheduleActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";
  formGroup: UntypedFormGroup;
  @ViewChild('runningTasksDropDown') runningTasksDropDown: ElementRef;
  @ViewChild('queuedTasksDropDown') queuedTasksDropDown: ElementRef;
  runningTasks: UntypedFormControl;
  queuedTasks: UntypedFormControl;
  runningTasksList: any[];
  queuedTasksList: any[];
  runningTasksValues: any[];
  queuedTasksValues: any[];


  private unsubscribe: Subject<void> = new Subject();
  constructor(
              private taxReturnService: TaxReturnService,
              private config: ConfigStateService,
              private  processStateService: ProcessStateService,
              @Optional() private dialogRef?: MatDialogRef<SchedulePackageGeneration>,
              @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<SchedulePackageGeneration>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return  (this.runningTasks.value === "" && this.queuedTasks.value === "") || this.scheduleActionState==='LOADING';
  }

  ngOnInit() {
    this.scheduleActionState = 'OPENED';
    this.errorMessage = '';
    if (!this.batchId) {
      this.errorMessage = 'This action can only be applied to a batch. Select a batch and try again.';
      return;
    }
    this.processStateService.getBulkEntityProcessState(`generate_${this.year}_%`, 'client', this.clientId).subscribe(result => {
      this.runningTasksList = result.filter(r => r.state === 'R');
      this.queuedTasksList = result.filter(r => r.state === 'Q');
      this.initDropdown();
    })
  }

  initDropdown() {
    this.formGroup = new UntypedFormGroup({});
    this.runningTasks = new UntypedFormControl("");
    this.queuedTasks = new UntypedFormControl("");
    this.formGroup.addControl("runningTasks", this.runningTasks);
    this.formGroup.addControl("queuedTasks", this.queuedTasks);

    setTimeout(() => {
      this.initRunningTasksDropDown();
      this.initQueuedTasksDropDown();
    });
  }

  initRunningTasksDropDown() {

    if (this.runningTasksList && this.runningTasksList.length) {
      this.runningTasksValues = [
        {
          name: "Select one of these...",
          value: "",
          selected: this.runningTasks
        }
      ];

      this.runningTasksValues = [
        ...this.runningTasksValues,
        ...this.runningTasksList
        .map(tt => {
          return {
            value: tt.id,
            name: this.currentBatchList.find(b => Number(tt.process.replace(`generate_${this.year}_`, '')) === b.id).name,
            selected: this.runningTasks
          };
        })
      ];

      $(this.runningTasksDropDown.nativeElement).dropdown({
        placeholder: "Select one of these...",
        fullTextSearch: "exact",
        values: this.runningTasksValues,
        onChange: (value: string) => {
          this.runningTasks.setValue(value);
        }
      });
    }

  }

  initQueuedTasksDropDown() {
    if (this.queuedTasksList && this.queuedTasksList.length) {
      this.queuedTasksValues = [
        {
          name: "Or select one of these...",
          value: "",
          selected: this.queuedTasks
        }
      ];

      this.queuedTasksValues = [
        ...this.queuedTasksValues,
        ...this.queuedTasksList
        .map(tt => {
          return {
            value: tt.id,
            name: this.currentBatchList.find(b => Number(tt.process.replace(`generate_${this.year}_`, '')) === b.id).name,
            selected: this.queuedTasks
          };
        })
      ];

      $(this.queuedTasksDropDown.nativeElement).dropdown({
        placeholder: "Or select one of these...",
        fullTextSearch: "exact",
        values: this.queuedTasksValues,
        onChange: (value: string) => {
          this.queuedTasks.setValue(value);
        }
      });
    }

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  scheduleGeneration() {
    if (this.runningTasks.value && this.queuedTasks.value) {
      this.errorMessage = "Please select only one process";
      this.scheduleActionState = 'OPENED';
    }else {
      this.errorMessage = '';
      this.scheduleActionState = 'LOADING';
      this.taxReturnService.schedulePackageGeneration({
        taxReturnIds: this.selectedTaxReturnIds,
        batchId: parseInt(this.batchId),
        clientId: parseInt(this.clientId),
        taxYear: parseInt(this.year),
        //followProcessId: this.runningTasks.value || this.queuedTasks.value,
        generationType: 'DRAFT',
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.scheduleActionState = 'COMPLETED';
      }, error => {
        this.errorMessage = "Something went wrong, please try again later.";
        this.scheduleActionState = 'OPENED';
        return;
      });
    }
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
